<template>
  <section class="code">
    <span> {{ $t("password.received_code") }} </span>

    <v-form
      @submit.prevent="sendTokenCode"
      v-model="formValidation"
      lazy-validation
      ref="form"
      class="form"
    >
      <v-otp-input
        v-model="token"
        :rules="[rules.requerid]"
        dense
        length="5"
      ></v-otp-input>
    </v-form>

    <section class="new__code">
      <span class="new__code--waiting" v-if="checkTime">
        {{ $t("password.email_sent") }}
        <span class="time">{{ formattedTime }}</span>
        {{ $t("password.to_try_again") }}
      </span>

      <section class="new__code--resend" v-else>
        <span>
          {{ $t("password.not_received") }}
        </span>

        <a @click="resetTime">
          {{ $t("password.click_here") }}
        </a>
      </section>
    </section>

    <v-btn
      class="border__radius-10 btn__default btn"
      color="primary"
      height="40"
      depressed
      :disabled="isLoading || !checkCode"
      :loading="isLoading"
      block
      @click="sendTokenCode"
    >
      {{ $t("buttons.advance") }}
      <v-icon class="icon" size="18">mdi-arrow-right</v-icon>
    </v-btn>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import formRules from "@/mixins/formRules";
import { setCode, setEmail } from "@/services/password";

export default {
  name: "PasswordTokenComponent",

  data: () => ({
    token: "",

    timer: null,
    minutes: 0,
    seconds: 30,

    isLoading: false,
  }),

  computed: {
    ...mapGetters({
      storeResource: "getPasswordDetails",
    }),

    checkCode() {
      return this.token.length === 5;
    },

    formattedTime() {
      const minutes = this.minutes < 10 ? "0" + this.minutes : this.minutes;
      const seconds = this.seconds < 10 ? "0" + this.seconds : this.seconds;
      return `${minutes}:${seconds}`;
    },

    checkTime() {
      return this.minutes > 0 || this.seconds > 0;
    },
  },

  mixins: [formRules],

  created() {
    this.timeToResend();
  },

  methods: {
    ...mapActions(["changePasswordDetails", "changePasswordStep"]),

    timeToResend() {
      this.timer = setInterval(() => {
        if (this.seconds > 0) {
          this.seconds--;
        } else if (this.minutes > 0) {
          this.minutes--;
          this.seconds = 59;
        }
      }, 1000);
    },

    resetTime() {
      if (this.resendEmail()) {
        clearInterval(this.timer);

        this.minutes = 2;
        this.seconds = 30;
        this.timeToResend();
      }
    },

    async resendEmail() {
      const { response, status } = await setEmail({
        email: this.storeResource.email,
      });

      if (status) {
        return status;
      }

      this.$snackbar.setParams(
        "error",
        this.$t("messages.error_not_defined"),
        response.message
      );
    },

    async sendTokenCode() {
      if (this.$refs.form.validate()) {
        this.isLoading = true;

        const data = {
          email: this.storeResource.email,
          token: this.token,
        };

        const { response, status } = await setCode(data);

        if (status) {
          this.changePasswordDetails(data);
          this.changePasswordStep("Passwords");
        } else {
          this.$snackbar.setParams(
            "error",
            this.$t("messages.error_not_defined"),
            response.message
          );
        }

        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

.code {
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 15px;

  .form {
    padding: 0 40px;
  }

  .new__code {
    font-size: 12px;

    &--waiting {
      .time {
        font-variant: tabular-nums;
        color: $blue;
      }
    }

    &--resend {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 0;
    }
  }

  .icon {
    position: absolute;
    right: 0px;
  }
}
</style>
